import "./footer.css";
import footer from "./images/footer.svg";
export default function Footer() {
  return (
    <div>
      <div className="img-grid-text">
        Arată cine ești și fii gata să strălucești. <br />
        <span>pentru tine.</span>
        <br />
        Răsfață-te cu bijuteriile care vorbesc despre tine. <br />
      </div>
      <section className="section1 footer-down">
        <div className="footer1">
          <div className="footer-complete">
            <div className="footer-column-desktop">
              <p className="title-footer-down">ABOUT TEILOR</p>
              <ul>
                <li>
                  <a href="/" target="/">
                    Teilor'S Universe
                  </a>
                </li>
                <li>
                  <a href="/" target="/">
                    Blog
                  </a>
                </li>
                <li>
                  <a href="/" target="/">
                    Careers
                  </a>
                </li>
                <li>
                  <a href="/" target="/">
                    GDPR policy
                  </a>
                </li>
                <li>
                  <a href="/" target="/">
                    Terms & conditions
                  </a>
                </li>
                <li>
                  <a href="/" target="/">
                    Video surveillance policy
                  </a>
                </li>
                <li>
                  <a href="/" target="/">
                    Cookies policy
                  </a>
                </li>
              </ul>
            </div>
            <div
              className="bottom-logos"
              style={{ backgroundImage: `url(${footer})` }}
            >
              <a
                // target="_blank"
                // rel="noopener noreferrer"
                className="teilor-main-link-bottom"
                href={"https://www.teilor.ro/"}
              ></a>
            </div>
            <div className="copy">© TEILOR SRL 2021</div>
          </div>
        </div>
      </section>
    </div>
  );
}
